import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import AllProducts from '../AllProducts';
import ActiveListings from './ActiveListings';
import PendingListings from './PendingListings';
import SoldListings from './SoldListings';
import RejectedListings from './RejectedListings';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import SingleProduct from '../SingleProduct';

const AllListingsPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleCanvas = () => {
        setIsOpen(!isOpen);
    };

    const handleRefresh = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setIsOpen(true);
    };

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h2>All Listings</h2>
                <div className='d-flex align-items-center justify-content-end'>
                    <div className="me-3">
                        <input
                            type="text"
                            className="form-control w-300px rounded-50 ps-3"
                            style={{ height: '50px' }}
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>
            </div>

            <AllProducts
                key={refreshKey}
                searchQuery={searchQuery}
                statusFilter=""
                onProductClick={handleProductClick}
            />

            <Offcanvas isOpen={isOpen} toggle={toggleCanvas} className="custom-canvas-width" direction='end'>
                <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCanvas}>
                    <span className='font-weight-bold'>{selectedProduct?.title || 'Product Details'}</span>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <SingleProduct product={selectedProduct} onSuccess={handleRefresh} />
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

const ListingsLayout = () => {
  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content' style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
        <Routes>
          <Route index element={<AllListingsPage />} />
          <Route path="active" element={<ActiveListings />} />
          <Route path="pending" element={<PendingListings />} />
          <Route path="sold" element={<SoldListings />} />
          <Route path="rejected" element={<RejectedListings />} />
          <Route path="*" element={<Navigate to="/products" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default ListingsLayout;

